import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';
import { map } from 'rxjs/operators';
import { AppHttpClient } from 'common/service/app-http-client.service';
import { prepareClientFormApiUrl } from 'projects/evide-client/src/app/app.const';
import { environment } from 'src/environments/environment';

interface IContactReferencePreview {
  reference: string;
  provisional: boolean;
}

/**
 * Contact reference generator. Returns a PROVISIONAL peek at the next LICENSE-wide sequential reference
 * (numeric, seeded at 300000+, with the project's optional prefix, e.g. POD306124) that the form pre-fills
 * into the (editable) reference field when a NEW contact form opens. The number is not reserved — the real,
 * unique-across-the-license reference is assigned on save. Calls the client endpoint
 * (ClientEvideForm/GenerateContactReference) in the client app, the admin one otherwise, mirroring how
 * ExecuteRuleService switches URLs.
 */
@Injectable({ providedIn: 'root' })
export class ContactReferenceService {
  constructor(private http: AppHttpClient) {}

  public generate(): Observable<string> {
    const url = (window as any).clientApp
      ? prepareClientFormApiUrl('GenerateContactReference')
      : `${environment.baseUrl}Contact/GenerateContactReference`;
    return this.http
      .get<IContactReferencePreview>(url)
      .pipe(map((res) => res?.reference ?? ''));
  }
}
